module.exports = __webpack_public_path__ + "img/sleeve upper arm width.5a3faf09.png";